import $ from 'jquery'
import Swiper from 'swiper'

$(function () {
  $('.tabs-container').each(function () {
    let $container = $(this)
    let $swiperElement = $container.find('.swiper-container')
    let $nav = $container.find('.tabs-nav')
    let $navItems = $nav.find('li')
    let activeClass = 'active'
    let $ul = $nav.find('ul')
    let resizeTimer
    let $toggleButton = $container.find('.tabs-nav')
    let mobileClass = 'is-mobile'
    let spaceLimit = 9999

    let hasEnoughSpace = function () {
      let hasEnoughSpace = false
      let navWidth = $nav.outerWidth()
      let necessarySpace = 0
      $navItems.each(function (item) {
        necessarySpace += $(this).outerWidth(true)
      })
      if (navWidth + 2 >= necessarySpace) {
        hasEnoughSpace = true
        if (!$nav.hasClass(mobileClass)) spaceLimit = necessarySpace
      }
      return hasEnoughSpace
    }

    let isMobile = function () {
      return !hasEnoughSpace() && !($nav.outerWidth() >= spaceLimit)
    }

    let setMobile = function () {
      if (isMobile()) {
        $nav.addClass(mobileClass)
        $nav.css('height', $ul.find('li.active').outerHeight() + 'px')
      } else {
        $nav.removeClass(mobileClass)
        $nav.css('height', 'auto')
      }
    }

    setMobile()

    $(window).on('resize', function (e) {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(function () {
        setMobile()
      }, 250)
    })

    $toggleButton.on('click', function () {
      if (isMobile()) {
        $nav.toggleClass('active')
      }
    })

    let swiper = new Swiper($swiperElement.get(0), {
      threshold: 30,
      autoHeight: true,
    })

    swiper.on('slideChange', function () {
      $navItems.removeClass(activeClass)
      $navItems.eq(swiper.activeIndex).addClass(activeClass)
    })

    $swiperElement.find('.accordion-heading').on('accordion:toggled', function () {
      swiper.updateAutoHeight(300)
    })

    $navItems.on('click', function (e) {
      swiper.slideTo($(this).attr('data-index'), 500)
      if ($(this).attr('data-ref')) {
        window.location.hash = $(this).attr('data-ref')
      }
    })

    let selectedTab = window.location.hash
    selectedTab = selectedTab.toLowerCase()
    selectedTab = selectedTab.slice(1)
    if (selectedTab) {
      let navElement = $nav.find("li[data-ref ='" + selectedTab + "']")
      if (navElement.length > 0 && navElement.attr('data-ref').length > 0) {
        let tabIndex = $(navElement).attr('data-index')
        swiper.slideTo(tabIndex, 0, false)
        $('html,body').animate({ scrollTop: $nav.offset().top }, 800)
      } else {
        // Necessary as swiper might change height after dom load and hash navigation would already be over
        window.scrollTo(0, $(window.location.hash).offset().top)
      }
    }
  })
})
